import { watch, ref } from 'vue'
import { isString } from '@/utils/is'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useI18n } from '@/hooks/web/useI18n'
import { useRoute } from 'vue-router'
import { isAdminSystemUrl } from '@/utils/routerHelper'

export const useTitle = (newTitle?: string) => {
  const { t } = useI18n()
  const appStore = useAppStoreWithOut()
  const route = useRoute()

  // 判断当前是否为客户端路由（非管理后台）
  const isClientRoute = !isAdminSystemUrl(route.path)

  const title = ref(
    newTitle
      ? isClientRoute
        ? `${t(newTitle as string)}`
        : `${appStore.getTitle} - ${t(newTitle as string)}`
      : appStore.getTitle
  )

  watch(
    title,
    (n, o) => {
      if (isString(n) && n !== o && document) {
        document.title = n
      }
    },
    { immediate: true }
  )

  return title
}
